import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  FirstName = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[a-zA-Z\s]*$/) // Only allows alphabets and spaces
  ]);
  LastName = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[a-zA-Z\s]*$/) // Only allows alphabets and spaces
  ]);
  Email = new FormControl('', [
    Validators.required,
    Validators.email // Ensures valid email format
  ]);
  PhoneNumber = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]{10}$/) // Only allows 10-digit numbers
  ]);
  Message = new FormControl('', [Validators.required]);
  successMessage: any;

  constructor(private titleService: Title, private metaService: Meta, public service: SharkifyAiSerivceService,

  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Contact Us for Customized Digital Marketing Solutions | Sharkify AI');
    this.metaService.addTags([
      {
        name: 'description',
        content:
          'Get in touch with Sharkify AI for expert digital marketing solutions. We deliver customized strategies designed to boost your brand and drive business success | 7075451542'
      },
      {
        name: 'keywords',
        content: 'Contact Us for Customized Digital Marketing Solutions'
      }
    ]);
  }

  // Error handling for First Name
  getFirstNameError() {
    if (this.FirstName.hasError('required')) {
      return 'First Name is required.';
    } else if (this.FirstName.hasError('pattern')) {
      return 'Only alphabets are allowed.';
    }
    return '';
  }

  // Error handling for Last Name
  getLastNameError() {
    if (this.LastName.hasError('required')) {
      return 'Last Name is required.';
    } else if (this.LastName.hasError('pattern')) {
      return 'Only alphabets are allowed.';
    }
    return '';
  }

  // Error handling for Email
  getEmailError() {
    if (this.Email.hasError('required')) {
      return 'Email is required.';
    } else if (this.Email.hasError('email')) {
      return 'Enter a valid email address.';
    }
    return '';
  }

  // Error handling for Phone Number
  getMobileNumberError() {
    if (this.PhoneNumber.hasError('required')) {
      return 'Phone Number is required.';
    } else if (this.PhoneNumber.hasError('pattern')) {
      return 'Enter a valid 10-digit number.';
    }
    return '';
  }

  // Disable the send button if the form is invalid
  formInvalid(): boolean {
    return (
      this.FirstName.invalid ||
      this.LastName.invalid ||
      this.Email.invalid ||
      this.PhoneNumber.invalid ||
      this.Message.invalid
    );
  }
  sendEmail() {
    if (this.formInvalid()) return;
    
    const contactDetails = {
      firstName: this.FirstName.value,
      lastName: this.LastName.value,
      emailId: this.Email.value,
      phoneNumber: this.PhoneNumber.value,
      message: this.Message.value
    };

    this.service.ContactUs(contactDetails).subscribe(
      (response) => {
        this.successMessage = response.message;
        this.FirstName.reset();
        this.LastName.reset();
        this.Email.reset();
        this.PhoneNumber.reset();
        this.Message.reset();
      },
      (error) => {
        // this.errorMessage = 'Failed to send message. Please try again.';
        console.log('Failed to send message. Please try again.')
      }
    ).add(() => {
      // this.isLoading = false;
    });
  }
  
  
}
